import {
    ADD_FLIGHT_TO_JET_LAG_TRIP,
    UPDATE_FLIGHT_TO_JET_LAG_TRIP,
    REMOVE_FLIGHT_FROM_JET_LAG_TRIP,
    RESET_JET_LAG_TRIP,
    ADD_FLIGHTS_TO_STATE
} from 'actions/ActionTypes';

const defaultFlight = {
    originLocation: '',
    originDate: null,
    originTime: '',
    destinationLocation: '',
    destinationDate: null,
    destinationTime: ''
};
const INITIAL_STATE = {
    trip: {
        flights: [{ ...defaultFlight }, { ...defaultFlight, isReturnFlight: true }], // round trip by default,
        isOneWay: false
    }
};

const addFlightToTrip = (state, action) => {
    const { stepNumber } = action.payload;
    const newTrip = { ...state.trip };

    const index = stepNumber || newTrip.flights.length - 1;
    newTrip.flights.splice(index, 0, { ...defaultFlight });

    return {
        ...state,
        trip: newTrip
    };
};

const updateFlightToTrip = (state, action) => {
    const { flightState, stepNumber } = action.payload;

    const newFlight = {
        ...state.trip.flights[stepNumber - 1],
        ...flightState
    };

    const newFlights = [...state.trip.flights];
    newFlights.splice(stepNumber - 1, 1, newFlight);

    return {
        ...state,
        trip: {
            ...state.trip,
            flights: newFlights,
            isOneWay: newFlight.isReturnFlight ? false : state.trip.isOneWay
        }
    };
};

const removeFlightFromTrip = (state, action) => {
    const { stepNumber } = action.payload;

    const newFlights = [...state.trip.flights];
    let isOneWayTrip = false;

    if (newFlights[stepNumber - 1].isReturnFlight) {
        // remove all details from the return flight, but do not remove the flight entirely
        // return flight can be removed only if we have an one way trip
        newFlights[stepNumber - 1] = { ...defaultFlight, isReturnFlight: true };
        isOneWayTrip = true;
    } else {
        newFlights.splice(stepNumber - 1, 1);
    }

    return {
        ...state,
        trip: {
            ...state.trip,
            flights: newFlights,
            isOneWay: isOneWayTrip
        }
    };
};

const addFlightsToState = (state, action) => {
    const { flights } = action.payload;
    const newFlights = [...flights];

    if (flights.length === 1) {
        newFlights.push({ ...defaultFlight, isReturnFlight: true });
    }

    return {
        ...state,
        trip: {
            ...state.trip,
            flights: newFlights
        }
    };
};

const resetJetLagTrip = (state) => {
    return {
        ...INITIAL_STATE
    };
};
export const getTrip = (state) => state.jetLagSetupTrip.trip;

const handlers = {
    [ADD_FLIGHT_TO_JET_LAG_TRIP]: addFlightToTrip,
    [UPDATE_FLIGHT_TO_JET_LAG_TRIP]: updateFlightToTrip,
    [REMOVE_FLIGHT_FROM_JET_LAG_TRIP]: removeFlightFromTrip,
    [RESET_JET_LAG_TRIP]: resetJetLagTrip,
    [ADD_FLIGHTS_TO_STATE]: addFlightsToState
};

export default function jetLagSetupTrip(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}
